<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="selectCompany">
            <van-loading
                class="pageLogin"
                v-if="isloading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title="选择公司"
                left-arrow
                @click-left="onClickLeft"
                @click-right="addTo"
            >
                <template #right>
                    <van-icon name="plus" size="18"></van-icon>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="value" @search="gitListData" placeholder="请输入搜索信息"></van-search>
                <ul class="list">
                    <template v-for="(item, index) in listData">
                        <li
                            :key="index"
                            @click="confirmSelection(item)"
                        >
                            {{ item.name }}
                        </li>
                    </template>
                </ul>
                <van-action-sheet
                    v-model="addToShow"
                    cancel-text="取消"
                    class="contactInfo"
                >
                    <h5>客户类型</h5>
                    <template v-for="(item, index) in addToData">
                        <p :key="index" @click="openAddTo(item)">
                            {{ item.name }}
                        </p>
                    </template>
                </van-action-sheet>
            </section>
        </div>
    </v-touch>
</template>

<script>
export default {
    // 选择用户
    name: 'select-company',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/clueRegistration') {
            this.$store.commit('noKeepAlive', 'select-company');
        }
        next();
    },
    props: {},
    data() {
        return {
            value: '',
            isloading: '',
            addToData: [],
            // 列表集合
            listData: [],
            // 线索登记数据
            clueDataData: {},
            addToShow: false,
        };
    },
    computed: {},
    watch: {},
    created() {
        // 客户类型
        this.getbycode('addToData', '002-FL0');
        // 线索登记数据
        this.clueDataData = this.$route.params.clueData;
    },
    activated() {
        this.addToShow = false;
        // 获取列表数据
        this.gitListData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/clueRegistration' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/clueRegistration' });
        },
        // 通过code拉取字典信息
        async getbycode(type, parentCode) {
            await this.$axios.get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=' + parentCode)
                .then(res => {
                    this[type] = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取列表数据
        gitListData() {
            this.isloading = true;
            this.$axios
                .get(`/interfaceApi/sale/client_manager/get_clients?Keywords=${this.value}`)
                .then(res => {
                    this.listData = res;
                    this.isloading = false;
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error });
                });
        },
        // 确认选择
        confirmSelection(data) {
            this.$router.isBack = 1;
            this.clueDataData.client_name = data.name;
            this.clueDataData.client_id = data.id;
            this.clueDataData.uniform_social_credit_code = data.license_code;
            this.clueDataData.client_contact_name = data.client_contact_name;
            this.clueDataData.client_contact_phone = data.client_contact_phone;
            this.$router.replace({
                path: '/clueRegistration',
                query: {
                    data: this.clueDataData,
                },
            });
        },
        // 录入上拉菜单打开
        addTo() {
            this.addToShow = true;
        },
        // 打开录入页面
        openAddTo(item) {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/customerEntry',
                query: {
                    customerType: item.code,
                    parentPageName: '/selectCompany',
                },
            });
        },
    },
};
</script>
<style lang="stylus">
.selectCompany
    height 100%
    .van-search
        height 44rpx
        background #E6E6E7
        .van-cell
            padding 3rpx 8rpx 3rpx 0
        .van-search__content
            border-radius 4rpx
            background #fff
            .van-field__control
                &::placeholder
                    color #D7D7D7 !important
    section
        height calc(100% - 45rpx)
        overflow: hidden;
        .list
            height calc(100% - 45rpx)
            overflow scroll
            -webkit-overflow-scrolling touch
            li
                height 46rpx
                background #fff
                border-bottom 1px solid #F0F0F0
                font-size 15rpx
                line-height 46rpx
                color #333333
                padding-left 15rpx
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
        .contactInfo
            h5,p
                font-size 16rpx
                line-height 45rpx
                text-align center
            h5
                color #333333
                background #F8F8F8
            p
                color #0189FC
                border-bottom 1px solid  #F0F0F0
</style>